/**
 * @flow
 * @format
 */
/* eslint-disable class-methods-use-this */

import React from 'react';
import { Row, Col } from 'reactstrap';
import _ from 'lodash';

import { getPosition } from '~/utils';

// import debug from '~/utils/macros/debug.macro';
// import classes from './GraphRowPaderator.scss';

type PropsType = {
  target: string,
  graphTarget: string,
};

export class GraphRowPaderator extends React.Component<PropsType, *> {
  static defaultProps = {};

  node: ?HTMLElement;
  timerHandle: ?TimeoutID;
  onResizeOrScroll: () => void;
  calculatePadding: () => void;

  onResizeOrScroll() {
    window.requestAnimationFrame(this.calculatePadding);
  }

  calculatePadding() {
    const target = document.getElementById(this.props.target);
    const graphTarget = document.getElementById(this.props.graphTarget);

    if (!target || !graphTarget) return;

    const targetOffset = getPosition(target);
    const graphOffset = getPosition(graphTarget);
    const offset = graphOffset.y - targetOffset.y - target.clientHeight;

    // $FlowIgnore
    this.node.style.paddingTop = `${offset}px`;
  }

  constructor() {
    super();
    this.node = null;
    this.timerHandle = null;
    this.onResizeOrScroll = this.onResizeOrScroll.bind(this);
    this.calculatePadding = this.calculatePadding.bind(this);
    this.onResizeOrScroll = _.debounce(this.onResizeOrScroll, 100);
  }

  componentDidMount() {
    this.timerHandle = setTimeout(() => {
      this.calculatePadding();

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.onResizeOrScroll);
        window.addEventListener('scroll', this.onResizeOrScroll);
      }
    }, 250);
  }

  componentDidUpdate() {
    this.calculatePadding();
  }

  componentWillUnmount() {
    if (this.timerHandle !== null) clearTimeout(this.timerHandle);
    window.removeEventListener('resize', this.onResizeOrScroll);
    window.removeEventListener('scroll', this.onResizeOrScroll);
  }

  render() {
    return (
      <Row>
        <Col>
          <div
            className="d-none d-lg-block"
            ref={c => {
              if (!c) return;
              this.node = c;
            }}
          />
        </Col>
      </Row>
    );
  }
}

export default GraphRowPaderator;



// WEBPACK FOOTER //
// ./src/components/GraphRowPaderator/GraphRowPaderator.js